/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The CharsetForSnapshotRequest model module.
 * @module model/CharsetForSnapshotRequest
 * @version v0
 */
export default class CharsetForSnapshotRequest {
  /**
   * Constructs a new <code>CharsetForSnapshotRequest</code>.
   * @alias module:model/CharsetForSnapshotRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CharsetForSnapshotRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CharsetForSnapshotRequest} obj Optional instance to populate.
   * @return {module:model/CharsetForSnapshotRequest} The populated <code>CharsetForSnapshotRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CharsetForSnapshotRequest();
      if (data.hasOwnProperty('charsetName'))
        obj.charsetName = ApiClient.convertToType(data['charsetName'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} charsetName
 */
CharsetForSnapshotRequest.prototype.charsetName = undefined;

